import { useState, useRef } from 'react';
import { createUserEmailPassword } from '../firebase';

import '../App.css';

const CreateAccount = () => {
  const textInput = useRef();
  const [submittedUsers, setSubmittedUsers] = useState([]);
  const [submittedUserErrors, setSubmittedUserErrors] = useState([]);

  const onSubmitClick = () => {
    const inputValue = textInput.current.value;
    textInput.current.value = '';
    const names = inputValue
      .split(/\r?\n/)
      .filter((u) => u.trim().length !== 0);

    if (names.length === 0) {
      setSubmittedUsers([]);
      setSubmittedUserErrors([]);
      return;
    }
    const currentSubmittedUsers = [];
    const currentSubmittedUserErrors = [];
    const promises = [];

    for (const name of names) {
      const password = generatePassword();

      const promise = retryCreateAccount(name, password, 10)
        .then((username) => {
          currentSubmittedUsers.push({ name, username, password });
        })
        .catch((error) => {
          currentSubmittedUserErrors.push(`${name}: ${error}`);
        });

      promises.push(promise);
    }

    Promise.all(promises).then((values) => {
      setSubmittedUsers(currentSubmittedUsers);
      setSubmittedUserErrors(currentSubmittedUserErrors);
    });
  };

  return (
    <div className="App" style={{ justifyContent: 'center' }}>
      <h1>Create Accounts</h1>
      <div
        style={{
          minHeight: '100vh',
          width: '100%',
          justifyContent: 'center',
          alignContent: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <form
          style={{
            height: '50%',
            width: '100%',
            justifyContent: 'center',
            alignContent: 'center',
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '30px',
          }}
        >
          <textarea
            style={{
              height: '400px',
              width: '60%',
              marginBottom: '20px',
              fontSize: '20px',
            }}
            ref={textInput}
          />
          <br />
          <button
            type="button"
            onClick={onSubmitClick}
            style={{ width: '40%', height: '30px', marginBottom: '30px' }}
          >
            Submit
          </button>
          <br />
        </form>
        <div
          style={{
            height: '60%',
            width: '100%',
            textAlign: 'center',
            textJustify: 'center',
            justifyContent: 'start',
            display: 'flex',
            paddingTop: '40px',
            flexDirection: 'column',
          }}
        >
          {submittedUsers.length > 0 && (
            <>
              <h4>Submitted Users</h4>
              {submittedUsers.map((user, index) => (
                <p
                  key={index}
                  style={{
                    width: '100%',
                  }}
                >
                  {`${user.name}: ${user.username}, ${user.password}`}
                </p>
              ))}
            </>
          )}
        </div>
        <div
          style={{
            height: '60%',
            width: '100%',
            textAlign: 'center',
            textJustify: 'center',
            justifyContent: 'start',
            display: 'flex',
            paddingTop: '40px',
            flexDirection: 'column',
            color: 'red',
          }}
        >
          {submittedUserErrors.length > 0 && (
            <>
              <h4>Errors</h4>
              {submittedUserErrors?.map((msg, index) => (
                <p
                  key={index}
                  style={{
                    width: '100%',
                  }}
                >
                  {msg}
                </p>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const retryCreateAccount = async (name, password, retries) => {
  let error = '';
  for (let i = 1; i <= retries; i++) {
    const username = generateUsername(name);
    const email = convertToEmail(username);

    try {
      await createUserEmailPassword(email, password);

      return Promise.resolve(username);
    } catch (currError) {
      error = `Failed to create randomized username after ${i} attempts [${currError.code}]`;
      if (currError.code !== 'auth/email-already-in-use') {
        return Promise.reject(error);
      }
    }
  }

  return Promise.reject(error);
};

const generateUsername = (name) => {
  return getInitials(name) + getRandomDigits(2);
};

const generatePassword = () => {
  return getRandomWord() + getRandomDigits(3);
};

const getInitials = (name) => {
  return name
    .trim()
    .split(' ')
    .map((x) => x.charAt(0))
    .join('')
    .substr(0, 2)
    .toLowerCase();
};

const getRandomDigits = (numDigits) => {
  let randDigitsStr = '';

  for (let i = 0; i < numDigits; i++) {
    const randNum = Math.floor(Math.random() * 10);
    randDigitsStr += randNum.toString();

    for (const blockedNum of blockedNumbers) {
      if (randDigitsStr.includes(blockedNum)) {
        i--;
        randDigitsStr = randDigitsStr.slice(0, -1);
        break;
      }
    }
  }

  return randDigitsStr;
};

const getRandomWord = () => {
  return wordBank[Math.floor(Math.random() * wordBank.length)];
};

const wordBank = [
  'dog',
  'cat',
  'fun',
  'car',
  'bus',
  'pet',
  'bed',
  'box',
  'boy',
  'cow',
  'day',
  'dog',
  'egg',
  'eye',
  'leg',
  'man',
  'men',
  'pig',
  'sun',
  'top',
  'toy',
  'way',
  'baby',
  'back',
  'ball',
  'bear',
  'bell',
  'boat',
  'cake',
  'coat',
  'corn',
  'doll',
  'door',
  'duck',
  'farm',
  'feet',
  'fire',
  'girl',
  'hand',
  'head',
  'hill',
  'home',
  'milk',
  'name',
  'nest',
  'rain',
  'ring',
  'seed',
  'shoe',
  'snow',
  'song',
  'time',
  'wind',
  'wood',
  'game',
  'tree',
  'fish',
  'bird',
];

const blockedNumbers = ['69', '420', '666'];

function convertToEmail(username) {
  return `${username.trim()}@rewriters.9dots.org`;
}

export default CreateAccount;
